export const FETCH_COOLDOWN_TASKS_REQUEST = 'FETCH_COOLDOWN_TASKS_REQUEST';
export const FETCH_COOLDOWN_TASKS_SUCCESS = 'FETCH_COOLDOWN_TASKS_SUCCESS';
export const FETCH_COOLDOWN_TASKS_FAILURE = 'FETCH_COOLDOWN_TASKS_FAILURE';

export const FETCH_COOLDOWN_TASK_DETAIL_REQUEST = 'FETCH_COOLDOWN_TASK_DETAIL_REQUEST';
export const FETCH_COOLDOWN_TASK_DETAIL_SUCCESS = 'FETCH_COOLDOWN_TASK_DETAIL_SUCCESS';
export const FETCH_COOLDOWN_TASK_DETAIL_FAILURE = 'FETCH_COOLDOWN_TASK_DETAIL_FAILURE';
export const CLEAR_COOLDOWN_TASK_DETAIL = 'CLEAR_COOLDOWN_TASK_DETAIL';
